var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoNegativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.8 25.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #af2c02;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,9.9c0,.9.6,1.7,1.3,1.7s1.3-.7,1.3-1.7-.6-1.7-1.3-1.7-1.3.7-1.3,1.7ZM17.9,9.9c0,.9-.6,1.7-1.3,1.7s-1.3-.7-1.3-1.7.6-1.7,1.3-1.7,1.3.7,1.3,1.7ZM18.4,18.5c-.2-.3-2.1-2.7-5.4-2.8-3.5,0-5.5,2.5-5.7,2.8M24.9,12.9c0,6.6-5.4,12-12,12S.8,19.5.8,12.9,6.2.8,12.9.8s12,5.4,12,12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoNegativo);
export default __webpack_public_path__ + "static/media/emo-negativo.097a95ae9ba4fbda182b303dc2ed727d.svg";
export { ForwardRef as ReactComponent };